import React from 'react';
import BodyRow, { IBodyRowProps } from './BodyRow';
import { BodyCellPure } from '../BodyCell';

const BodyRowPure = React.forwardRef((props: IBodyRowProps, ref) => (
  <BodyRow
    { ...props }
    ref={ ref }
    bodyCellComponent={ BodyCellPure }
  />
));

export default React.memo(BodyRowPure);
